import Textarea, { TextareaProps } from './Textarea';

export type { TextareaProps };
export default Textarea;
